import Typography from '@mui/material/Typography';
import type { ComponentType } from 'react';
import { GeneralData } from './components/GeneralData/GeneralData';
import { HouseholdProfile } from './components/HouseholdProfile/HouseholdProfile';
import type { InsightsGridColumnSpan } from './components/InsightsGrid/InsightsGrid';
import { OccupationGroup } from './components/OccupationGroup/OccupationGroup';

// Placeholder tiles mirroring the target layout — replace with chart components as they land
const createPlaceholder = (title: string): ComponentType => {
  const Placeholder = () => {
    return <Typography variant="h3">{title}</Typography>;
  };
  return Placeholder;
};

export type InsightsTileConfig = {
  id: string;
  columns: InsightsGridColumnSpan;
  component: ComponentType;
  disablePadding?: boolean;
};

export const tiles: InsightsTileConfig[] = [
  { id: 'general-data', columns: 2, component: GeneralData, disablePadding: true },
  { id: 'household-profile', columns: 1, component: HouseholdProfile, disablePadding: true },
  { id: 'community-type', columns: 1, component: createPlaceholder('Community Type') },
  { id: 'reach-by-state', columns: 2, component: createPlaceholder('Reach by State') },
  { id: 'household-income', columns: 2, component: createPlaceholder('Household Income') },
  { id: 'occupation-group', columns: 1, component: OccupationGroup, disablePadding: true },
  { id: 'device-type', columns: 1, component: createPlaceholder('Device Type') },
  { id: 'household-composition', columns: 1, component: createPlaceholder('Household Composition') },
  { id: 'children-in-household', columns: 1, component: createPlaceholder('Children in Household') },
  { id: 'deal-performance', columns: 3, component: createPlaceholder('Deal Performance') },
];
